import { useState } from "react";
import "./CreateOrder.scss";
import { adminApi } from "../../../utils/api";
import { showSuccessToast, showErrorToast } from "../../../utils/toastNotifications";

export const CreateOrder = () => {
  const [formData, setFormData] = useState([
    {
      key: Date.now(),
      link: "",
      merchantName: "",
      description: "",
      quantity: 1,
      width: 0,
      height: 0,
      length: 0,
      weight: 0,
    },
  ]);

  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleInputChange = (index, event) => {
    const { name, value } = event.target;
    const updatedFormData = [...formData];
    updatedFormData[index][name] = value;
    setFormData(updatedFormData);
  };

  // Handle quantity change
  const handleQuantityChange = (index, increment) => {
    const updatedFormData = [...formData];
    const newQuantity = updatedFormData[index].quantity + increment;
    updatedFormData[index].quantity = newQuantity > 1 ? newQuantity : 1; // Ensure quantity doesn't go below 1
    setFormData(updatedFormData);
  };

  // Add a new row
  const addNewRow = () => {
    setFormData([
      ...formData,
      {
        key: Date.now(),
        link: "",
        merchantName: "",
        description: "",
        quantity: 1,
        width: 0,
        height: 0,
        length: 0,
        weight: 0,
      },
    ]);
  };

  // Delete a row
  const deleteRow = (key) => {
    setFormData(formData.filter((item) => item.key !== key));
  };

  // Submit order
  const submitOrder = async () => {
    setLoading(true);

    try {
      const response = await adminApi.call('/adminorder', 'POST', { Orders: formData });

      if (!response.success) {
        showErrorToast(response.error || "Failed to create order");
        return;
      }

      showSuccessToast("Order created successfully!");
      setFormData([
        {
          key: Date.now(),
          link: "",
          merchantName: "",
          description: "",
          quantity: 1,
          width: 0,
          height: 0,
          length: 0,
          weight: 0,
        },
      ]); // Reset form
    } catch (error) {
      showErrorToast("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-center mb-3">Create Order</h2>

      {/* Add row button */}
      <div className="text-center mt-3">
        <button className="btn btn-success" onClick={addNewRow}>
          <i className="fa fa-plus"></i> Add New Item
        </button>
      </div>

      <br />

      <div className="row">
        <table className="table table-striped table-bordered text-center">
          <thead className="table-dark">
            <tr>
              <th>Link</th>
              <th>Merchant Name</th>
              <th>Description</th>
              <th>Quantity</th>
              <th>Width</th>
              <th>Height</th>
              <th>Length</th>
              <th>Weight</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {formData.map((item, index) => (
              <tr key={item.key}>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="link"
                    value={item.link}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="merchantName"
                    value={item.merchantName}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    name="description"
                    value={item.description}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      className="btn btn-outline-primary btn-sm rounded-circle me-1"
                      onClick={() => handleQuantityChange(index, -1)}
                    >
                      −
                    </button>
                    <span className="px-2">{item.quantity}</span>
                    <button
                      className="btn btn-outline-primary btn-sm rounded-circle ms-1"
                      onClick={() => handleQuantityChange(index, 1)}
                    >
                      +
                    </button>
                  </div>
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    name="width"
                    value={item.width}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    name="height"
                    value={item.height}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    name="length"
                    value={item.length}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    name="weight"
                    value={item.weight}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </td>
                <td>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteRow(item.key)}
                  >
                    <i className="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Submit button */}
      <div className="text-center mt-4">
        <button
          className="btn btn-primary"
          onClick={submitOrder}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Order"}
        </button>
      </div>
    </div>
  );
};
